import { SVGProps } from 'react';

const MarsStroke = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m14 6 4 4m3-3V3h-4m4 0-7.75 7.75M15 15a6 6 0 1 1-12 0 6 6 0 0 1 12 0"
    />
  </svg>
);
export default MarsStroke;
